import { SignupShell } from '@/features/auth/components/SignupShell';
import { LoginForm } from '@/features/auth/components/LoginForm';
import { useLoginPage } from '@/features/auth/hooks/useLoginPage';
import { LOGIN_OTP_LENGTH } from '@/features/auth/utils/loginIdentifier';

export function LoginPage() {
  const login = useLoginPage();

  return (
    <SignupShell>
      <LoginForm
        form={login.form}
        loginMethod={login.loginMethod}
        otpSent={login.otpSent}
        otpDigits={login.otpDigits}
        otpError={login.otpError}
        showPassword={login.showPassword}
        phoneConfig={login.phoneConfig}
        isPhoneInput={login.isPhoneInput}
        isLoading={login.isLoading}
        submitLabel={login.submitLabel}
        resendSeconds={login.resendSeconds}
        onSwitchMethod={login.switchMethod}
        onOtpChange={(next) => {
          login.setOtpDigits(next);
          if (next.join('').length === LOGIN_OTP_LENGTH) login.setOtpError('');
        }}
        onTogglePassword={() => login.setShowPassword((value) => !value)}
        onSendOtp={() => void login.handleSendOtp()}
        onChangeIdentifier={() => {
          login.setOtpSent(false);
          login.resetOtpDigits();
        }}
        onSubmit={login.onSubmit}
      />
    </SignupShell>
  );
}
